import {Centre} from "../styled/Center.styled";

function Account(props) {
    return <Centre>
    <h1>Account</h1>
    <p>To be added soon!!!</p>
</Centre>;
}

export default Account;